import React from "react";
import FairDetailsCard from "./FairDetailsCard";
import styled from "styled-components";
import { WhiteButton } from "../Button";
import { trackFairDetailsStudentReorder } from "../../DumbleData";

interface Props {
	language: string;
}

const StudentReorderCard = ({ language }: Props) => {

	const handleReorderClick = () => {
		trackFairDetailsStudentReorder();
		window.location.href = "https://bookfairstoolkit.scholastic.ca/cgi-bin/lansaweb?procfun+F4WEB02+FSGNW01";
	};

	return (
		<FairDetailsCard title={language === "en" ? "Student Reorder" : "Commande prépayée des élèves"}>
			<Body>{language === "en" ? "To place a Student Reorder, please click the button below. You will be redirected to Online Tools and prompted to login. " : "Pour passer une commande prépayée des élèves, cliquez sur le bouton ci-dessous. Vous serez redirigés vers les outils en ligne et vous pourrez vous connecter à votre compte."}</Body>
			<WhiteButton
				whiteBackground={true} 
				handleClick={handleReorderClick}>
				{language === "en" ? "Place Student Reorder" : "Passer la commande"}
			</WhiteButton>
		</FairDetailsCard>
	);
};

const Body = styled.div`
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	padding-bottom: 24px;
`;

export default StudentReorderCard;